var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26701(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26701",
    "data-name": "Group 26701",
    transform: "translate(-1252 -788)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(1252 788)",
    fill: "#1e8d3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23258",
    "data-name": "Path 23258",
    d: "M817.279,104.214H794.841a5.2,5.2,0,0,1-4.4-7.951l8.588-13.813-.131-11.065h-.52a1.747,1.747,0,0,1-1.693-1.759V68.454a1.761,1.761,0,0,1,1.758-1.759h15.11a1.747,1.747,0,0,1,1.693,1.759v1.172a1.7,1.7,0,0,1-1.693,1.759h-.52V82.45l8.654,13.813a5.206,5.206,0,0,1-4.4,7.951m-4.924-14.07-3.527-5.687a2.344,2.344,0,0,1-.43-1.348l0-11.725h-4.689l0,11.725a1.988,1.988,0,0,1-.487,1.347l-3.529,5.688Z",
    transform: "translate(482.353 738.305)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26701);
export default __webpack_public_path__ + "static/media/Group 26701.d58dd34e985216c2a062fa2517174847.svg";
export { ForwardRef as ReactComponent };